import React from 'react';
import PropTypes from 'prop-types';
import "./rscard.css"
import CurrencyFormat from 'react-currency-format';

const RsCardImgv4  = ({ title, description, iconClass, userdetail, isResponsive }) => {
  return (
  <div className="card rs-card-v4 bg-v2 rs-card-compact">
  <div className="card-body py-2 px-3">
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-5">
            {!isResponsive && (
                <div className='imgIcon'>
                
                <img src={iconClass} width={36} alt="icon" className="mb-1" />
                 </div>
            )}
          
             <div className='titleText'>
               <h3> {title}</h3>
            </div>
              <div className='titleDesc'>
                <h3>
                 {title === "Lead to client conversion" ? (
                description + "%"
              ) : (
                description
              )}
                </h3>
            </div>
    </div>
    </div>
  </div>
</div>

  );
};

RsCardImgv4.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
  userdetail: PropTypes.object,
  isResponsive:PropTypes.object
};

RsCardImgv4.defaultProps = {
  title: 'Default Title',
  description: 'Default Description',
  iconClass: 'bx-default-icon',
};

export default RsCardImgv4;